import React, { useState, useCallback } from 'react'
import { ReportTableRow } from '../../../../components/Table/types'
import { Column } from '../../../../redux/context/periodGroups/hooks'
import { StatementColumn } from '../../../financialStatements'
import { EnhancedStatementRow } from '../../../financialStatements/utils/dataEnhancement'
import VoucherModal from './VoucherModal'

export interface VoucherModalData {
  row: ReportTableRow | EnhancedStatementRow
  column: Column | StatementColumn
}

type OpenVoucherModal = (data: VoucherModalData) => void

export const useVoucherModal = (): [React.ReactNode, OpenVoucherModal] => {
  const [open, setOpen] = useState(false)
  const [data, setData] = useState<VoucherModalData | null>(null)

  const openModal = useCallback((newData: VoucherModalData) => {
    setData(newData)
    setOpen(true)
  }, [])

  const closeModal = useCallback(() => {
    setOpen(false)
    setData(null)
  }, [])

  const modal = data ? <VoucherModal row={data.row} column={data.column} open={open} onClose={closeModal} /> : null

  return [modal, openModal]
}

export type UseVoucherModalReturn = ReturnType<typeof useVoucherModal>
